import React from "react";
import { Form, Spinner } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import MarkDownEditor from "../../../../../../components/markdownEditor/MarkDownEditor";
import "./UpdateDepartmentDialog.css";

class UpdateDepartmentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      identifier: {
        defaultValue: "",
        rule: ValidationHelper.isNonEmptyString,
      },
      description: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: true,
        rule: ValidationHelper.isNonEmptyExtendedDescription,
      },
      creatorType: {
        defaultValue: 0,
        rule: (value) => ValidationHelper.isIntInRange(value, 0, 1),
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && this.props.show !== prevProps.show) {
      this.setState({
        validation: ValidationHelper.getValidation(
          {
            identifier: {
              defaultValue: this.props.class.identifier,
              rule: ValidationHelper.isNonEmptyString,
            },
            description: {
              defaultValue: this.props.class.description,
              initValid: true,
              rule: ValidationHelper.isNonEmptyExtendedDescription,
            },
            creatorType: {
              defaultValue: 0,
              rule: (value) => ValidationHelper.isIntInRange(value, 0, 1),
            },
          },
          true
        ),
      });
    } else if (!this.props.show && this.props.show !== prevProps.show) {
      this.setState({
        validation: ValidationHelper.getValidation(
          this.validationDefinition,
          true
        ),
      });
    }
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Organisation.DepartmentTabbar.UpdateDepartmentDialog.Title")}
        dialogApiError={this.props.dialogApiError}
        rightButtonText={t(
          "Organisation.DepartmentTabbar.UpdateDepartmentDialog.Submit"
        )}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonText={t(
          "Organisation.DepartmentTabbar.UpdateDepartmentDialog.Cancel"
        )}
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <div style={this.props.isUpdating ? { textAlign: "center" } : {}}>
            {this.props.isUpdating ? (
              <Spinner animation="border" />
            ) : (
              <Form>
                <Form.Group controlId="formClassName">
                  <Form.Label>
                    {t(
                      "Organisation.DepartmentTabbar.UpdateDepartmentDialog.Identifier"
                    )}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="identifier"
                    placeholder={t(
                      "Organisation.DepartmentTabbar.UpdateDepartmentDialog.IdentifierPlaceholder"
                    )}
                    value={this.state.validation.identifier.value}
                    isInvalid={!this.state.validation.identifier.isValid}
                    onChange={this.handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(
                      "Organisation.DepartmentTabbar.UpdateDepartmentDialog.ValidationError.Name"
                    )}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                  <MarkDownEditor
                    label="Beschreibung"
                    defaultValue={
                      this.props.class?.description ||
                      ValidationHelper.getDefaultValueExtendedDescription()
                    }
                    onChange={(value) =>
                      this.handleChange({
                        target: {
                          name: "description",
                          value: value,
                        },
                      })
                    }
                  />
                  <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.description.isValid}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(
                      "Organisation.DepartmentTabbar.UpdateDepartmentDialog.ValidationError.Description"
                    )}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form>
            )}
          </div>
        }
      />
    );
  }
}

export default withTranslation()(UpdateDepartmentDialog);
